import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineCreateApi extends BaseClient {
  public doMachineCreate (data: any) {
    const path:string = '/v1/machines'
    const formData = new FormData()
    formData.append('machine_name', data.machine_name)
    formData.append('is_valid', data.is_valid)
    formData.append('machine_type', data.machine_type)
    formData.append('buy_date', data.buy_date)
    formData.append('model', data.model)
    formData.append('serial_number', data.serial_number)
    formData.append('maker_address', data.maker_address)
    formData.append('remarks', data.remarks)

    // 値があるもののみリクエスト
    if (data.image_path !== null && data.image_path !== undefined) {
      formData.append('image', data.image)
    }
    if (data.working_width !== null && data.working_width !== undefined) {
      formData.append('working_width', data.working_width)
    }
    if (data.working_height !== null && data.working_height !== undefined) {
      formData.append('working_height', data.working_height)
    }
    if (data.weight !== null && data.weight !== undefined) {
      formData.append('weight', data.weight)
    }
    if (data.working_time !== null && data.working_time !== undefined) {
      formData.append('working_time', data.working_time)
    }
    if (data.working_performance !== null && data.working_performance !== undefined) {
      formData.append('working_performance', data.working_performance)
    }
    /* 共通処理 */
    return super.donotUseContentType().setBody(formData).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new MachineCreateApi()
